import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from "@mui/material";
import React from "react";
import { FEEDBACK_TYPE_FEATURE_REQ } from "../../model";

interface AutoAssignSettingsFeatureProps {
  isAutoAssign: any;
  handleIsAutoAssignChange: (event: any, type: string) => void;
  autoAssignConfig: any;
  availableSource: any;
  handleAutoAssignInputSourceChange: (
    event: any,
    type: string,
    feedbackType: string
  ) => void;
}

const FeatureRequest = ({
  isAutoAssign,
  handleIsAutoAssignChange,
  autoAssignConfig,
  availableSource,
  handleAutoAssignInputSourceChange,
}: AutoAssignSettingsFeatureProps) => {
  return (
    <Grid item xs={12}>
      <Box className="feedback-autoassign-wrap tab-content">
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              ml: "4px",
              padding: "16px 16px 16px 0px",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  name="isAutoAssign"
                  checked={isAutoAssign[FEEDBACK_TYPE_FEATURE_REQ]}
                  onChange={(e) =>
                    handleIsAutoAssignChange(e, FEEDBACK_TYPE_FEATURE_REQ)
                  }
                  color="primary"
                />
              }
              label="Auto assign to CSM"
            />
          </Box>
        </Grid>
      </Box>
      <Grid item xs={12}>
        <FormControl className="custom-select">
          <InputLabel>Select Sources for Auto Assignment</InputLabel>
          <Select
            style={{ minWidth: "300px" }}
            labelId="source-select"
            id="source-select"
            value={
              autoAssignConfig[FEEDBACK_TYPE_FEATURE_REQ]?.inputSource || []
            }
            label="Sources"
            onChange={(e: any) =>
              handleAutoAssignInputSourceChange(
                e,
                "inputSource",
                FEEDBACK_TYPE_FEATURE_REQ
              )
            }
            multiple
            input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
            renderValue={(selected: any) => {
              return (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((id: any) => {
                    return <Chip key={id} label={id} />;
                  })}
                </Box>
              );
            }}
          >
            {availableSource?.map((value: any) => {
              return (
                <MenuItem key={value} value={value}>
                  {value}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default FeatureRequest;
